module.exports = __webpack_public_path__ + "static/media/aboutTitle.5c4a65b9.svg";